module.exports = __webpack_public_path__ + "img/rate-us.50e8505e.png";